/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';

/**
 * 
 * @export
 * @interface ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleATransferSchedule
 */
export interface ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleATransferSchedule {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleATransferSchedule
     */
    LineNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleATransferSchedule
     */
    AmountInvolved?: string;
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName}
     * @memberof ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleATransferSchedule
     */
    NameOfNoncharitableEO?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleATransferSchedule
     */
    DescriptionOfTransfersEtc?: string;
}

/**
 * Check if a given object implements the ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleATransferSchedule interface.
 */
export function instanceOfExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleATransferSchedule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleATransferScheduleFromJSON(json: any): ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleATransferSchedule {
    return ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleATransferScheduleFromJSONTyped(json, false);
}

export function ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleATransferScheduleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleATransferSchedule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'LineNumber': !exists(json, 'LineNumber') ? undefined : json['LineNumber'],
        'AmountInvolved': !exists(json, 'AmountInvolved') ? undefined : json['AmountInvolved'],
        'NameOfNoncharitableEO': !exists(json, 'NameOfNoncharitableEO') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON(json['NameOfNoncharitableEO']),
        'DescriptionOfTransfersEtc': !exists(json, 'DescriptionOfTransfersEtc') ? undefined : json['DescriptionOfTransfersEtc'],
    };
}

export function ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleATransferScheduleToJSON(value?: ExecRiskApiAppApiV1EagerTasksForm990ModelsForm990ScheduleATransferSchedule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'LineNumber': value.LineNumber,
        'AmountInvolved': value.AmountInvolved,
        'NameOfNoncharitableEO': ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON(value.NameOfNoncharitableEO),
        'DescriptionOfTransfersEtc': value.DescriptionOfTransfersEtc,
    };
}

